<template></template>

<script>
export default {
    name: 'design-2021-lesson-show-component',
    props: ['lessonIn', 'fixedmenuIn'],
    data() {
        return {
            lesson: this.lessonIn,
            fixedmenu: this.fixedmenuIn,
            fixedslide: null,
            sidebarShow: false,
            stepIndex: 0,
            sidebarButtons: {
                silence: false,
                phone: false,
                whisper: false,
                disturb: false,
            },
            currentTime: null,
            currentDate: null,
            stopwatchTime: '00:00:00',
            stopwatchRunning: false,
            stopwatchStartDate: null,
            stopwatchInterval: null,
            stopwatchFinished: false,
            countdownInterval: null,
            countdownTime: 10,
            countdownStartDate: null,
            countdownRunning: false,
            audiocontext: new AudioContext(),
        };
    },
    computed: {
        selectedStep() {
            let step = this.lesson.steps[this.stepIndex];
            if (step.selectedSlideIndex === undefined) {
                step.selectedSlideIndex = 0;
            }
            return step;
        },
        selectedSlide() {
            return this.fixedslide === null
                ? this.selectedStep.slides[this.selectedStep.selectedSlideIndex]
                : this.fixedslide;
        },
        isEditableSlide() {
            return this.fixedslide === null;
        },
        hasButtonAddRow() {
            return this.selectedSlide.type == 3;
        },
        hasButtonSwitchSingleDouble() {
            return this.selectedSlide.type == 3 || this.selectedSlide.type == 4;
        },
    },
    mounted() {
        window.addEventListener('keydown', (e) => {
            if (e.keyCode == 39) {
                this.onClickNextSlide();
            } else if (e.keyCode == 37) {
                this.onClickPreviousSlide();
            } else if (e.keyCode == 32) {
                this.onClickNextSlide();
            }
        });
    },
    methods: {
        slideUpdated(slide) {
            this.lesson.steps = this.lesson.steps.map((step) => {
                step.slides = step.slides.map((s) => (s.id === slide.id ? slide : s));
                return step;
            });
        },
        showGenerator() {
            var slide = {};
            slide.type = 6;
            this.fixedslide = slide;
        },
        startCountdown() {
            this.countdownTime = 10;
            this.countdownRunning = true;

            if (this.countdownStartDate === null) {
                this.countdownStartDate = new Date();
                this.countdownStartDate.setSeconds(this.countdownStartDate.getSeconds() + this.countdownTime);
            }

            this.stopwatchInterval = setInterval(() => {
                var currentTime = new Date();

                if (this.countdownStartDate - currentTime < 0) {
                    this.stopCountDown();
                    return;
                }

                var timeElapsed = new Date(this.countdownStartDate - currentTime);

                if (timeElapsed.getUTCSeconds() != this.countdownTime) {
                    if (timeElapsed.getUTCSeconds() == 0) {
                        this.beep(75, 500, 1000);
                    } else {
                        this.beep(50, 250, 500);
                    }
                }

                this.countdownTime = timeElapsed.getUTCSeconds();
            }, 50);
        },
        stopCountDown() {
            clearInterval(this.countdownInterval);
            this.countdownTime = 10;
            this.countdownStartDate = null;
            this.countdownRunning = false;
        },
        getStopwatchFinished() {
            return this.stopwatchFinished ? 'red' : 'test';
        },
        startStopwatch() {
            this.stopwatchFinished = false;
            if (this.stopwatchRunning) return;

            if (this.stopwatchStartDate === null) {
                var times = this.stopwatchTime.split(':');
                var hour = parseInt(times[0]);
                var min = parseInt(times[1]);
                var sec = parseInt(times[2]);

                this.stopwatchStartDate = new Date();
                this.stopwatchStartDate.setMinutes(this.stopwatchStartDate.getMinutes() + min);
                this.stopwatchStartDate.setHours(this.stopwatchStartDate.getHours() + hour);
                this.stopwatchStartDate.setSeconds(this.stopwatchStartDate.getSeconds() + sec);
            }

            this.stopwatchRunning = true;
            this.stopwatchInterval = setInterval(() => {
                var currentTime = new Date();

                if (this.stopwatchStartDate - currentTime < 0) {
                    this.stopwatchFinished = true;
                    this.resetStopwatch();
                    return;
                }

                var timeElapsed = new Date(this.stopwatchStartDate - currentTime);

                var hour = timeElapsed.getUTCHours();
                var min = timeElapsed.getUTCMinutes();
                var sec = timeElapsed.getUTCSeconds();

                hour = ('00' + hour).slice(-2);
                min = ('00' + min).slice(-2);
                sec = ('00' + sec).slice(-2);

                this.stopwatchTime = hour + ':' + min + ':' + sec;
            }, 100);
        },
        resetStopwatch() {
            clearInterval(this.stopwatchInterval);
            this.stopwatchRunning = false;
            this.stopwatchTime = '00:00:00';
            this.stopwatchStartDate = null;
        },
        stopStopwatch() {
            this.stopwatchRunning = false;
            this.stopwatchFinished = false;
            clearInterval(this.stopwatchInterval);
        },
        addMinute() {
            this.stopwatchFinished = false;
            var times = this.stopwatchTime.split(':');
            times[1] = parseInt(times[1]) + 1;

            var hour = ('00' + times[0]).slice(-2);
            var min = ('00' + times[1]).slice(-2);
            var sec = ('00' + times[2]).slice(-2);

            this.stopwatchTime = hour + ':' + min + ':' + sec;
        },
        add5Seconds() {
            this.stopwatchFinished = false;
            var times = this.stopwatchTime.split(':');
            times[2] = parseInt(times[2]) + 5;
            var hour = ('00' + times[0]).slice(-2);
            var min = ('00' + times[1]).slice(-2);
            var sec = ('00' + times[2]).slice(-2);

            this.stopwatchTime = hour + ':' + min + ':' + sec;
        },
        updateCurrentTime() {
            this.currentTime = this.moment().format('HH:mm:ss');
        },
        onClickHomeLesson() {
            window.location.href = baseUrl + '/presentation';
        },
        onClickEditLesson() {
            window.location.href = baseUrl + '/presentation/' + this.lesson.id + '/edit';
        },
        onEditSlide() {
            window.location.href =
                baseUrl +
                '/presentation/' +
                this.lesson.id +
                '/edit/slide/' +
                this.selectedStep.slides[this.selectedStep.selectedSlideIndex].id;
        },
        onClickStep(index) {
            this.stepIndex = index;
            this.fixedslide = null;
        },
        onClickFixedSlide(slide) {
            this.fixedslide = slide;
        },
        onClickNextSlide() {
            this.fixedslide = null;

            if (this.selectedStep.selectedSlideIndex + 1 < this.selectedStep.slides.length) {
                this.selectedStep.selectedSlideIndex++;
                this.lesson.steps = this.lesson.steps.slice();
            } else {
                if (this.stepIndex + 1 === this.lesson.steps.length) {
                    return;
                }
                this.stepIndex++;
                this.selectedStep.selectedSlideIndex = 0;
            }
        },
        onClickPreviousSlide() {
            this.fixedslide = null;

            if (this.selectedStep.selectedSlideIndex !== 0) {
                this.selectedStep.selectedSlideIndex--;
                this.lesson.steps = this.lesson.steps.slice();
            } else {
                if (this.stepIndex === 0) {
                    return;
                }
                this.stepIndex--;
            }
        },
        beep(vol, freq, duration) {
            var v = this.audiocontext.createOscillator();
            var u = this.audiocontext.createGain();
            v.connect(u);
            v.frequency.value = freq;
            v.type = 'sine';
            u.connect(this.audiocontext.destination);
            u.gain.value = vol * 0.01;
            v.start(this.audiocontext.currentTime);
            v.stop(this.audiocontext.currentTime + duration * 0.001);
        },
        onClickAddRow() {
            this.$refs.slidecontainer.onClickAddRow();
        },
        onClickSwitchSingleDouble() {
            this.$refs.slidecontainer.onClickSwitchSingleDouble();
        },
    },
    created() {
        this.currentTime = this.moment().format('HH:mm:ss');
        this.currentDate = this.moment().format('dddd, DD MMM');
        setInterval(() => this.updateCurrentTime(), 200);
    },
};
</script>

<style>
.dropdown .dropdown-toggle {
    color: #fff !important;
}

.nav-link .dropdown button {
    padding: 1rem 2rem;
    font-size: 1rem !important;
    padding-left: 0px;
}
</style>

<style scoped>
.step-selected {
    background-color: rgb(56, 144, 207) !important;
    color: #fff;
}

.slide-navigation-arrow {
    cursor: pointer;
}
.slide-navigation-arrow:hover {
    color: blue;
}

@import 'https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700';

body {
    font-family: 'Poppins', sans-serif;
    background: #eee;
}

p {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1em;
    font-weight: 300;
    line-height: 1.7em;
}

a,
a:hover,
a:focus {
    color: inherit;
    text-decoration: none;
    transition: all 0.3s;
}

.navbar {
    background-image: linear-gradient(to right, rgb(48, 40, 126), rgb(56, 144, 207));
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    height: 60px;
}

.navbar-btn {
    box-shadow: none;
    outline: none !important;
    border: none;
}

.line {
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #ddd;
    margin: 40px 0;
}

/* ---------------------------------------------------
        SIDEBAR STYLE
    ----------------------------------------------------- */

.wrapper {
    display: flex;
    width: 100%;
}

#sidebar {
    width: 250px;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    background: #fff;
    z-index: 999;
    color: #fff;
    transition: all 0.3s;
    box-shadow: 0px 0px 5px #ccc;
}

#sidebar.active {
    margin-left: -250px;
}

#sidebar .sidebar-header {
    background: rgb(48, 40, 126) !important;
    text-align: center;
    height: 60px;
    line-height: 60px;
}

#sidebar .sidebar-header h3 {
    height: 90px;
    line-height: 90px;
}

#sidebar .sidebar-lesson-title {
    bottom: 205px;
    color: #000;
    position: absolute;
    padding: 5px;
}

#sidebar .sidebar-bottom {
    bottom: 0;
    left: 0;
    position: absolute;
    height: 205px;
    width: 100%;
    border-top: 1px solid #999;
    padding-top: 0px;
    padding-left: 15px;
}

#sidebar .sidebar-bottom .sidebar-button {
    width: 60px;
    height: 60px;
    line-height: 70px;
    text-align: center;
    background-color: rgb(56, 144, 207) !important;
    margin-left: 10px;
    float: left;
    margin-top: 5px;
    border-radius: 10px;
    cursor: pointer;
}
#sidebar .sidebar-bottom .sidebar-button:hover {
    opacity: 1;
}

#sidebar .sidebar-bottom .selected {
    opacity: 1;
}

.sidebar-notification {
    padding: 10px;
    font-size: 20px;
    border-radius: 10px;
    text-align: center;
    min-height: 50px;
    line-height: 32px;
    margin-top: 10px;
}

.sidebar-notification.red {
    background: red !important;
}

.nav-item .nav-link {
    padding-right: 0px;
    padding-left: 0px;
}

.nav-link button {
    color: #fff !important;
    font-size: 20px !important;
}

.nav-link button:hover {
    color: white !important;
}

.nav-link .fas {
    margin-right: 20px;
}

a[data-toggle='collapse'] {
    position: relative;
}

#menu-extra > .dropdown-toggle {
    padding-left: 0px !important;
}

.dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
}

.lesson-dropdown .btn-link {
    color: #fff !important;
}

.lesson-dropdown {
    color: #fff !important;
}

.lesson-dropdown .dropdown-toggle {
    color: #fff !important;
}

ul ul a {
    font-size: 0.9em !important;
    padding-left: 30px !important;
    background: #6d7fcc;
}

ul.CTAs {
    padding: 20px;
}

ul.CTAs a {
    text-align: center;
    font-size: 0.9em !important;
    display: block;
    border-radius: 5px;
    margin-bottom: 5px;
}

a.download {
    background: #fff;
    color: #fff;
}

a.article,
a.article:hover {
    background: #6d7fcc !important;
    color: #fff !important;
}

/* ---------------------------------------------------
        CONTENT STYLE
    ----------------------------------------------------- */

#content {
    width: calc(100% - 250px);
    min-height: 100vh;
    transition: all 0.3s;
    position: absolute;
    top: 0;
    right: 0;
}

#content.active {
    width: 100%;
}

#steps {
    float: left;
    width: 100px;
    margin-left: 20px;
}

#steps .step {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 20px;
    cursor: pointer;
}

#steps .step .number {
    display: block;
    height: 50px;
    width: 50px;
    line-height: 50px;
    text-align: center;
    background-color: #fff;
    border-radius: 50%;
    margin-bottom: 5px;
    margin-left: 25px;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 5px #ccc;
    font-size: 24px;
    font-weight: bold;
}

#steps .step.active {
    font-weight: bold;
}

#steps .step .number.active {
    background-color: #ddd;
}

#bottombar {
    height: 42px;
    float: right;
    width: calc(100% - 140px);
    padding-left: 20px;
    margin-top: 10px;
    margin-right: 20px;
}

#slides {
    float: left;
    width: calc(100% - 160px);
    margin-left: 20px;
    height: calc(100vh - 142px);
    background-color: #fff;
    border: 1px solid #eee;
    box-shadow: 0px 0px 5px #ccc;
    padding: 20px;
}

#slides p {
    font-size: 24px;
}

#slides h2 {
    font-size: 30px;
}

#sidebarCollapse {
    height: 50px;
    width: 50px;
    font-size: 25px;
}

#menu-extra li {
    /*margin-right: 20px;*/
}

#menu-extra li a {
    font-size: 20px;
    color: #000;
}

#menu-extra li a:hover {
    color: #fff;
}

/* ---------------------------------------------------
        MEDIAQUERIES
    ----------------------------------------------------- */

@media (max-width: 768px) {
    #sidebar {
        margin-left: -250px;
    }
    #sidebar.active {
        margin-left: 0;
    }
    #content {
        width: 100%;
    }
    #content.active {
        width: calc(100% - 250px);
    }
    #sidebarCollapse span {
        display: none;
    }
}

.sw-btn {
    background: #fff;
}

#countdown {
    height: 100%;
    width: 100%;
    background: #fff;
    position: absolute;
    z-index: 1000;
}

#cd-round {
    height: 400px;
    width: 400px;
    background: #0096d5;
    margin: auto;
    border-radius: 200px;
    margin-top: 100px;
    color: #fff;
    font-size: 250px;
    text-align: center;
    line-height: 400px;
}
</style>
